import { colorsDark } from '../colors.dark';

export const checkboxDark = {
  display: 'flex',
  width: 20,
  height: 20,
  borderStyle: 'solid',
  borderWidth: 1,
  borderRadius: 5,
  transition: 'all 150ms',
  borderColor: 'white',
  textStyle: {
    paddingLeft: 'xs',
    color: colorsDark['grey/dark'],
  },
  states: {
    '&:hover': {
      boxShadow: `0 0 0 3px ${colorsDark.primary}`,
    },
  },
  variants: {
    checked: {
      backgroundColor: colorsDark.primary,
      borderColor: colorsDark.primary,
      states: {
        '&:hover': {
          boxShadow: `0 0 0 3px ${colorsDark['grey/dark']}`,
        },
      },
    },
    disabled: {
      pointerEvents: 'none',
      opacity: 0.4,
      states: {
        '&:hover': {
          boxShadow: 'none !important',
        },
      },
    },
  },
};
